import React from 'react';

import iconTrackingDisable from 'img/icon-stock-not-available.svg';

import {
  ContainerTracking,
  ImgNoTracking,
  ContainerDescription,
  TitleTracking,
  DescriptionTracking,
  BtnTracking
} from './styles';
import { useSelector } from 'react-redux';
import { RootState } from 'store/ducks';
import { HideTrackingProps } from './interface';
import TicketServices from 'services/ticket.service';
import toast from 'components/Toast/dispatch';

const HideTracking: React.FC<HideTrackingProps> = (props) => {
  const { order } = props;
  const user = useSelector((state: RootState) => state.user);

  const _ticketService = new TicketServices();

  const createProtocol = async () => {
    const item: any = {
      protocolNumber: 0,
      legalPerson: order.company?.personType === "Juridica" ? 1 : 2,
      communicationChannel: "PORTAL_CC",
      protocolCategory: "LOGISTICA",
      ticketReason: "PREVISÃO DE ENTREGA",
      contactName: user?.fullName,
      contactMailAddress: user?.email,
      contactPhoneNumber: user?.phoneNumber,
      order: order,
      description: `Solicitação do tracking do pedido: ${order.protheusOrderSale}.`,
      tags: ["TRACKING DO PEDIDO", "SOLICITAÇÃO", "2A_VIA", "CUSTOMER_CARE"],
      linkTicketIdentifier: "",
      customerId: order.customerId,
      customerName: user?.fullName,
      attendenceType: "SELF_SERVICE"
    };

    const response = await _ticketService.create(item);

    if (response.status === 200) {
      const { data } = response.data;
      toast.success(`O protocolo ${data.protocolNumber} foi registrado com sucesso`);
    } else {
      toast.error('Ocorreu um erro durante a requisição');
    }
  };

  return (
    <ContainerTracking>
      <ImgNoTracking src={iconTrackingDisable} />
      <ContainerDescription>
        <TitleTracking>Tracking indisponível</TitleTracking>
        <DescriptionTracking>
          Desculpe, mas esse pedido não possui seu tracking disponível, mas você <br />pode solicitar a posição de entrega para o nosso time de atendimendo.
        </DescriptionTracking>
        <BtnTracking action={createProtocol} />
      </ContainerDescription>
    </ContainerTracking>
  );
};

export default HideTracking;